import { styled } from '@mui/system';
import COLORS from '../../../theme/Colors';
import FONTS_FAMILY from '../../../theme/FontsFamily';

export const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: '#F8FAFC',
    minHeight: '100vh',
    paddingBottom: '5rem',
    'html.dark &': {
        backgroundColor: '#000000',
    }
});

export const PageHeader = styled('div')({
    textAlign: 'center',
    padding: '3rem 0 3rem 0',
});

export const MainTitle = styled('h1')({
    fontFamily: 'Merriweather, Georgia, serif',
    color: '#202A5D',
    fontSize: '2.5rem',
    fontWeight: 700,
    marginBottom: '1.5rem',
});

export const SearchWrapper = styled('div')({
    maxWidth: '700px',
    margin: '0 auto',
    padding: '0 1.5rem',
    width: '100%'
});

export const ContentInner = styled('div')({
    width: '85%',
    maxWidth: '1000px',
    margin: '0 auto',
});

export const SectionTitle = styled('h2')({
    fontFamily: 'Merriweather, Georgia, serif',
    color: '#202A5D',
    fontSize: '1.5rem',
    fontWeight: 700,
    marginTop: '3rem',
    marginBottom: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    '&:after': {
        content: '""',
        flexGrow: 1,
        height: '1px',
        backgroundColor: '#E2E8F0',
    },
    'html.dark &:after': {
        backgroundColor: '#222222',
    }
});

// Breadcrumb Styles
export const BreadcrumbWrapper = styled('div')({
    backgroundColor: '#F1F5F9',
    borderBottom: '1px solid #E2E8F0',
    width: '100vw',
    position: 'relative',
    left: '50%',
    right: '50%',
    marginLeft: '-50vw',
    marginRight: '-50vw',
    marginTop: '-70px',
    zIndex: 10,
});

export const BreadcrumbInner = styled('div')({
    width: '85%',
    maxWidth: '1920px',
    margin: '0 auto',
    padding: '15px 1.5rem',
    display: 'flex',
    alignItems: 'center',
});

export const BreadcrumbContent = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontSize: '14px',
    fontWeight: 500,
    color: 'rgb(62, 63, 65)',
    textTransform: 'uppercase',
});

export const BreadcrumbLink = styled('span')({
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    }
});

export const BreadcrumbSeparator = styled('span')({
    margin: '0 4px',
    color: '#94A3B8',
});

export const BreadcrumbCurrent = styled('span')({
    color: 'inherit',
});

// Accordion Custom Styles
export const StyledAccordion = styled('div')(({ expanded }) => ({
    backgroundColor: 'white',
    borderRadius: '12px',
    border: '1px solid #E2E8F0',
    marginBottom: '1rem',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    boxShadow: expanded ? '0 10px 20px rgba(0,0,0,0.05)' : 'none',
    borderColor: expanded ? '#202A5D' : '#E2E8F0',
    '&:hover': {
        borderColor: '#202A5D',
    },
    'html.dark &': {
        backgroundColor: '#000000',
        borderColor: expanded ? '#7fb8e8' : '#222222',
    }
}));

export const AccordionHeader = styled('div')({
    padding: '1.25rem 1.5rem',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1rem',
    '&:hover': {
        backgroundColor: '#F8FAFC'
    },
    'html.dark &:hover': {
        backgroundColor: '#0a0a0a',
    }
});

export const QuestionText = styled('h4')(({ expanded }) => ({
    margin: 0,
    fontSize: '16px',
    fontWeight: 600,
    color: expanded ? '#202A5D' : '#4A5568',
    fontFamily: FONTS_FAMILY.bold.body,
    lineHeight: 1.4,
    'html.dark &': {
        color: expanded ? '#7fb8e8' : '#cbd5e1',
    }
}));

export const AccordionContent = styled('div')(({ expanded }) => ({
    maxHeight: expanded ? '1000px' : '0',
    padding: expanded ? '0 1.5rem 1.5rem 1.5rem' : '0 1.5rem',
    opacity: expanded ? 1 : 0,
    overflow: 'hidden',
    transition: 'all 0.4s ease-in-out',
}));

export const AnswerText = styled('div')({
    fontSize: '1rem',
    color: '#718096',
    lineHeight: 1.7,
    fontFamily: FONTS_FAMILY.regular.body,
    '& p': {
        margin: 0
    }
});
